export default __webpack_public_path__ + "static/media/hou 1.3bcce912.webp";